const ChoosePlanButton = ({ selectedPlan, onClick, onRemove, error }) => {
  return (
    <div className="pt-2 border-t">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onClick}
            className="inline-flex items-center px-4 py-2 rounded-md bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition"
          >
            Choose Plan
          </button>
          {error && <span className="text-sm text-red-600">{error}</span>}
        </div>

        {selectedPlan && (
          <div className="text-sm">
            <span className="text-gray-600 mr-2">Selected:</span>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-100 text-green-800 font-medium">
              {selectedPlan.name}
              <button
                type="button"
                onClick={onRemove}
                className="ml-1 hover:text-green-900"
                aria-label="Remove plan"
              >
                ×
              </button>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChoosePlanButton;
